export default "__VITE_ASSET__VOKHa6J___"